import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import Select from "react-select";

const CampaignFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
  onAddNewClick,
}) => {
  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  {/* <Button
                    color="primary"
                    size="sm"
                    onClick={() => setCurrentPage(1)}
                  >
                    <i className="bx bx-search me-2"></i>Apply Filters
                  </Button> */}
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>
                  <Button color="success" size="sm" onClick={onAddNewClick}>
                    <i className="bx bx-plus me-2"></i>
                    New Campaign
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="align-items-end justify-content-between g-3">
                {/* 🔹 Left Side (Search Filters) */}
                <Col md="8">
                  <Row className="g-3">
                    {/* Campaign Name */}
                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Campaign Name</Label>
                        <Input
                          type="text"
                          placeholder="Search by name..."
                          value={filters.name}
                          onChange={(e) =>
                            handleFilterChange("name", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* Status */}
                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Status</Label>
                        <Select
                          value={
                            filters.isActive === ""
                              ? null
                              : {
                                  value: filters.isActive,
                                  label:
                                    filters.isActive === "true"
                                      ? "Active"
                                      : "Inactive",
                                }
                          }
                          onChange={(selectedOption) =>
                            handleFilterChange(
                              "isActive",
                              selectedOption ? selectedOption.value : "",
                            )
                          }
                          options={[
                            { value: "", label: "All Status" },
                            { value: "true", label: "Active" },
                            { value: "false", label: "Inactive" },
                          ]}
                          isClearable
                          menuPlacement="auto"
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                          }}
                          placeholder="All Status"
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Visibility</Label>
                        <Select
                          value={
                            filters.isDraft === ""
                              ? null
                              : {
                                  value: filters.isDraft,
                                  label:
                                    filters.isDraft === "true"
                                      ? "Draft"
                                      : "Published",
                                }
                          }
                          onChange={(selectedOption) =>
                            handleFilterChange(
                              "isDraft",
                              selectedOption ? selectedOption.value : "",
                            )
                          }
                          options={[
                            { value: "", label: "All Status" },
                            { value: "true", label: "Draft" },
                            { value: "false", label: "Published" },
                          ]}
                          isClearable
                          menuPlacement="auto"
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                          }}
                          placeholder="All Status"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                {/* 🔹 Right Side (Button) */}
                {/* <Col
                  md="2"
                  className="d-flex justify-content-md-end align-items-center align-content-center justify-content-center"
                >
                  <Button color="success" size="md" onClick={onAddNewClick}>
                    <i className="bx bx-plus me-2"></i>
                    New Campaign
                  </Button>
                </Col> */}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CampaignFilterCard;
